import { mobileBreakpoint, tabletBreakpoint } from "../../lib/helper/viewportHelper"
import { makeStyles } from "@material-ui/core/styles"

const menuWidth = "fit-content"

export default makeStyles(theme => ({
    appBar: {
        boxShadow: "none",
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        width: "100%",
        [theme.breakpoints.up(mobileBreakpoint)]: {
            marginLeft: 0
        }
    },
    image: {
        marginRight: "10px"
    },
    productButton: {
        minWidth: 140,
        fontSize: "1rem"
    },
    mobileMenuButton: {
        justifyContent: "flex-start",
        display: "flex"
    },
    searchArea: {
        display: "flex",
        flexWrap: "wrap",
        paddingLeft: "1rem",
        gap: 8,
        marginRight: 8,
        [theme.breakpoints.down("lg")]: {
            justifyContent: "flex-end"
        }
    },
    flexContainer: {
        display: "flex",
        flexWrap: "wrap",
        boxSizing: "border-box",
        width: "100%"
    },
    desktopSearchAreaBox: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
    },
    flexWrap: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    toolbar: {
        display: "flex",
        width: "100%",
        maxWidth: 1600,
        margin: "5px auto",
        alignItems: "flex-start",
        [theme.breakpoints.down(tabletBreakpoint)]: {
            alignItems: "center"
        }
    },
    logo: {
        height: "80px",
        margin: "10px"
    },
    drawerPaper: {
        position: "relative",
        whiteSpace: "nowrap",
        width: menuWidth,
        color: "#404040",
        [theme.breakpoints.down(mobileBreakpoint)]: {
            width: "auto"
        }
    },
    badgePos: {
        transform: "scale(1) translate(60%, 0%)"
    },
    badge: {
        height: 25,
        minWidth: 25,
        fontSize: "0.85rem",
        borderRadius: 15
    },
    leftRightFilter: {
        width: 75,
        height: 60,
        paddingLeft: 4,
        marginTop: 4
    },
    flexRow: {
        display: "flex",
        flexDirection: "row"
    }
}))
